@if (data.title) {
  <h1 mat-dialog-title>{{ data.title | translate }}</h1>
}
<div mat-dialog-content>{{ data.content | translate }}</div>
<div mat-dialog-actions align="end">
  <button [mat-dialog-close]="false" mat-button>{{ 'general.button.close' | translate }}</button>
  <button [mat-dialog-close]="true" mat-button cdkFocusInitial>{{ 'general.button.ok' | translate }}</button>
</div>
